import sanitizeHtml from 'sanitize-html';

// const { sanitizeUrl } = require('@braintree/sanitize-url');

export default (html) => {
  // console.log('html: ', html);
  if (!html || html === '<p>null</p>') return null;
  const shtml = sanitizeHtml(html, {
    allowedTags: [
      'address',
      'article',
      'aside',
      'footer',
      'header',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'hgroup',
      'main',
      'nav',
      'section',
      'blockquote',
      'dd',
      'div',
      'dl',
      'dt',
      'figcaption',
      'figure',
      'hr',
      'li',
      'main',
      'ol',
      'p',
      'pre',
      'ul',
      'a',
      'abbr',
      'b',
      'bdi',
      'bdo',
      'br',
      'cite',
      'code',
      'data',
      'dfn',
      'em',
      'i',
      'img',
      'iframe',
      'kbd',
      'mark',
      'q',
      'rb',
      'rp',
      'rt',
      'rtc',
      'ruby',
      's',
      'samp',
      'small',
      'span',
      'strong',
      'sub',
      'sup',
      'time',
      'u',
      'var',
      'wbr',
      'caption',
      'col',
      'colgroup',
      'table',
      'tbody',
      'td',
      'tfoot',
      'th',
      'thead',
      'tr',
    ],
    // disallowedTagsMode: 'discard',
    disallowedTagsMode: 'escape',
    allowedAttributes: {
      a: ['href', 'name', 'target', 'style'],
      // We don't currently allow img itself by default, but this
      // would make sense if we did. You could add srcset here,
      // and if you do the URL is checked for safety
      img: ['src', 'srcset', 'style', 'width', 'height', 'alt'],
      '*': ['href', 'align', 'alt', 'center', 'bgcolor', 'style', 'height', 'width'],
      iframe: ['src', 'height', 'width', 'style'],
      p: ['style'],
    },
    allowedStyles: {
      '*': {
        // Match HEX and RGB
        color: [
          /^#(0x)?[0-9a-f]+$/i,
          /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
        ],
        'text-align': [/^left$/, /^right$/, /^center$/],
        // Match any number with px, em, or %
        'font-size': [/^\d+(?:px|em|%)$/],
      },
      p: {
        'font-size': [/^\d+rem$/],
      },
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
    // URL schemes we permit
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'data'],
    allowedSchemesByTag: {
      img: ['data'],
    },
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    allowedIframeHostnames: [
      'youtube.com',
      'www.youtube.com',
      'player.vimeo.com',
      'c360filestore.blob.core.windows.net',
      'win.myguardiangroup.com',
      'myguardiangroup.com',
      'myggonline.app',
      'www.myggonline.app',
      'surveymonkey.com',
      'www.surveymonkey.com',
    ],
  });

  return shtml;
};
